import {IGraphqlClient, createGraphqlClient} from '@wix/graphql-client';
import {IHttpClient} from '@wix/yoshi-flow-editor';

export function createAutoGraphqlClient(httpClient: IHttpClient): IGraphqlClient {
  // Add generic error handling or similar
  return createGraphqlClient(httpClient);
}
